import { ListItemText, Menu, MenuItem } from "@mui/material";
import { useMemo } from "react";
import MaterialTypography from "../../../../../../components/MaterialTypography";
import MaterialBox from "../../../../../../components/MaterialBox";

const Waffle = ({ open, anchorEl, handleClose }) => {

  const modules = useMemo(() => {
  const data = sessionStorage.getItem("WaffleModules");
    return data ? JSON.parse(data) : [];
  }, []);
  
  const handleNavigate = (route) => {
    if (route) {
      window.location.replace(route);     
       
    }
    handleClose();
  };

  const toTitleCase = (text = "") =>
  text.replace(/\w\S*/g, (word) =>
    word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
  );

  return (
    <Menu
    anchorEl={anchorEl}
    open={open}
    onClose={handleClose}
    anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
    }}
    transformOrigin={{
        vertical: "top",
        horizontal: "left",
    }}
    PaperProps={{
        elevation: 0,
        sx: {
        width: { xs: 180, sm: 200, md: 220 },
        borderRadius: 2,
        mt: 1,

        maxHeight: { xs: "60vh", sm: 400 }, // responsive height
        overflowY: "auto",
        overflowX: "auto",

        background: "rgba(255,255,255,0.9)",
        backdropFilter: "blur(10px)",
        WebkitBackdropFilter: "blur(10px)",

        boxShadow: "0 8px 24px rgba(0,0,0,0.15)",

        // better mobile scrolling
        "&::-webkit-scrollbar": {
            width: 6,
        },
        "&::-webkit-scrollbar-thumb": {
            background: "rgba(0,0,0,0.2)",
            borderRadius: 3,
        },
        },
    }}
    >
      <MaterialBox>
         <MaterialTypography
          variant="body2"
          sx={{
            px: 1.5,
            pb: 0.5,
            color: "#667085",
            fontWeight: 600,
            letterSpacing: "0.5px",
            textTransform: "uppercase",
            borderBottom: "1px solid #525252"
          }}
        >
          Other Modules
        </MaterialTypography>
      </MaterialBox>
      {modules.length === 0 && (
        <MenuItem disabled>No Modules Found</MenuItem>
      )}

      {modules.map((item, index) => {
        return (
          <MenuItem
            key={index}
            onClick={() => handleNavigate(item.redirectUrl)}
            sx={{
              minHeight: 32,
              py: 0.5,
              px: 1.5,
            }}
          >
            <ListItemText
              primary={toTitleCase(item?.base_module_name)}
              primaryTypographyProps={{
                fontSize: 13,
                fontWeight: 500,
              }}
            />
          </MenuItem>
        );
      })}
    </Menu>
  );
};

export default Waffle;